module.exports = __webpack_public_path__ + "static/media/web-pic.fdd98c00.svg";